import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getTripInformationSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { TripInformationConstants } from '../store/tripInformation.constants'
import { ITripInformationState } from '../store/tripInformation.types'
import { setAPIResponse } from '../store/tripInformation.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setDiagnosisDefaults } from './setDiagnosisDefaults.saga'

export function* saveTripInformation() {
  const tripInformation: ITripInformationState = yield select(getTripInformationSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (tripInformation.patientCategory && !pcrDoc.patient?.tripInformation?.patientCategory) {
      yield call(setDiagnosisDefaults, tripInformation.patientCategory, pcrDoc)
    }
    const pcrDocUpdated = {
      ...pcrDoc,
      patient: { ...pcrDoc.patient, tripInformation },
      dispatchId: tripInformation?.dispatchID.trim(),
    }
    try {
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setAPIResponse(response))
    } catch (e) {
      yield put(throwPcrException(`saveTripInformation() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveTripInformationSaga() {
  yield takeLatest(
    [
      TripInformationConstants.SET_BASE,
      TripInformationConstants.SET_UNIT,
      TripInformationConstants.SET_STAFFING_LEVEL,
      TripInformationConstants.SET_UNIT_EQUIPMENT,
      TripInformationConstants.SET_SHIFT,
      TripInformationConstants.SET_DISPATCH_ID,
      TripInformationConstants.SET_LOCAL_ID,
      TripInformationConstants.SET_REGISTRATION_TAIL_NUMBER,
      TripInformationConstants.SET_DISPATCH_PRIORITY,
      TripInformationConstants.SET_EMD_PERFORMED,
      TripInformationConstants.SET_EMD_PERFORMED_PNNV,
      TripInformationConstants.SET_EMD,
      TripInformationConstants.SET_TYPE_OF_SERVICE,
      TripInformationConstants.SET_STANDBY_PURPOSE,
      TripInformationConstants.SET_SCHEDULED,
      TripInformationConstants.SET_CALL_TYPE,
      TripInformationConstants.SET_PATIENT_CATEGORY,
      TripInformationConstants.SET_DISPATCHED_AS,
      TripInformationConstants.SET_DISPOSITION,
      TripInformationConstants.SET_UNIT_DISPOSITION,
      TripInformationConstants.SET_PATIENT_EVALUATION,
      TripInformationConstants.SET_PATIENT_EVALUATION_PNNV,
      TripInformationConstants.SET_CREW_DISPOSITION,
      TripInformationConstants.SET_CREW_DISPOSITION_PNNV,
      TripInformationConstants.SET_TRANSPORT_DISPOSITION,
      TripInformationConstants.SET_TRANSPORT_DISPOSITION_PNNV,
      TripInformationConstants.SET_REFUSAL_RELEASE_REASON,
      TripInformationConstants.SET_AMBULANCE_TRANSPORT_CODE,
      TripInformationConstants.SET_MASS_CASUALTY,
      TripInformationConstants.SET_MASS_CASUALTY_PNNV,
      TripInformationConstants.SET_VEHICLE_GRID,
      TripInformationConstants.SET_DISPATCH_LOCATION,
      TripInformationConstants.SET_VEHICLE_GPS_N,
      TripInformationConstants.SET_VEHICLE_GPS_E,
      TripInformationConstants.SET_VEHICLE_MILEAGE_END,
      TripInformationConstants.SET_VEHICLE_MILEAGE_START,
      TripInformationConstants.SET_VEHICLE_MILEAGE_REC,
      TripInformationConstants.SET_VEHICLE_MILEAGE_REF,
      TripInformationConstants.SET_VEHICLE_MILEAGE_LOADED,
      TripInformationConstants.SET_VEHICLE_MILEAGE_TOTAL,
      TripInformationConstants.SET_VEHICLE_MILEAGE_LPM,
      TripInformationConstants.SET_VEHICLE_MILEAGE_ODOM,
      TripInformationConstants.SET_VEHICLE_USNG,
      TripInformationConstants.SET_TEAM,
      TripInformationConstants.SET_TEAM_CARE_ONLY,
      TripInformationConstants.SET_EQUIPMENT,
      TripInformationConstants.SET_PROVIDER_ROLES,
      TripInformationConstants.SET_MAX_ALT,
      TripInformationConstants.SET_FLIGHT_PLAN,
    ],
    performWithMutexHOG,
    saveTripInformation
  )
}
